<template>
	<div>
		<navTitle><div class="pageTitle">个人资料</div></navTitle>

		<div class="applyForm">
			<div class="applyForm-line applyForm-lineUp flex flex-align-center flex-jus-between">
				<div class="left">头像</div>
				<div class="flex-1 right" v-if="realAvatar"><img :src="realAvatar" class="avatarImg" /></div>
				<van-uploader :max-count="1" :after-read="afterRead" />
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left">姓名</div>
				<input style="padding-right:12px;" v-model.trim="truename" type="text" class="flex-1" placeholder="请输入真实姓名" maxlength="12" />
			</div>

			<div @click="genderShow = true" class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left">性别</div>
				<div class="flex-1 right" style="color: #000" v-if="genderText">{{genderText}}</div>
				<div class="flex-1 right" v-else>请选择</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div @click="dateShow = true" class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left">出生年月</div>
				<div class="flex-1 right" style="color: #000" v-if="birthday">{{birthday}}</div>
				<div class="flex-1 right" v-else>请选择</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>
		</div>
		
		<div @click="save" class="submitBtn">保存</div>
		<van-popup v-model="genderShow" round position="bottom">
			<van-picker
				show-toolbar
				:columns="genderList"
				@confirm="genderConfirm"
				@cancel="genderCancel"
			/>
		</van-popup>
		<van-popup v-model="dateShow" round position="bottom">
			<van-datetime-picker
				v-model="currentDate"
				type="year-month"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="dateConfirm"
				@cancel="dateCancel"
			/>
		</van-popup>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			avatar: '',
			realAvatar: '',
			truename: '',
			sex: '',
			birthday: '',
			genderShow: false,
			genderList: [
				{
					text: '男',
					value: 1
				},
				{
					text: '女',
					value: 2
				}
			],
			genderText: '',
			currentDate: '',
			dateShow: false,
			currentDate: new Date(1980, 0, 1),
			minDate: new Date(1900, 0, 1),
			maxDate: new Date(new Date().getFullYear(), new Date().getMonth())
		};
	},
	created() {
		this.getUserInfo()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '个人资料',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getUserInfo() {
			this.$get('api/user/userInfo').then(res => {
				let result = res.data
				this.realAvatar = result.avatar
				this.avatar = result.avatar
				this.truename = result.truename
				this.birthday = result.birthday
				this.genderText = result.sex == 1? '男': result.sex == 2 ? '女' : ''
				this.sex = result.sex
			})
		},
		afterRead(file) {
			let formData = new FormData()
			formData.append('file', file.file)
			this.$post('api/common/upload', formData, {
				'Content-Type':'multipart/form-data'
			}).then(res => {
				this.avatar = res.data.src
				this.realAvatar = res.data.url
			})
		},
		genderConfirm(e) {
			this.genderText = e.text
			this.sex = e.value
			this.genderCancel()
		},
		genderCancel() {
			this.genderShow = false
		},
		dateConfirm(e) {
			let year = new Date(e).getFullYear()
			let month = new Date(e).getMonth() + 1
			month = month < 10 ? '0' + month : month
			this.birthday = `${year}-${month}`
			this.dateCancel()
		},
		dateCancel() {
			this.dateShow = false
		},
		save() {
			if (!this.avatar) {
				this.$toast('请上传头像')
				return
			}
			if (!this.truename) {
				this.$toast('请输入姓名')
				return
			}
			if (!this.sex) {
				this.$toast('请选择性别')
				return
			}
			if (!this.birthday) {
				this.$toast('请选择出生年月')
				return
			}
			this.$post('api/user/userUpdate', {
				avatar: this.avatar,
				truename: this.truename,
				sex: this.sex,
				birthday: this.birthday
			}).then(res => {
				this.$toast('保存成功')
				setTimeout(() => {
					this.$router.go(-1)
				}, 750);
			})
		}
	}
};
</script>

<style scoped lang="stylus">
.submitBtn
	position fixed
	left calc(50% - 188px)
	bottom 80px
	width 376px
	height 92px
	line-height 92px
	text-align center
	background-image url('~@/static/images/index/btnBG.png')
	background-size 100% 100%
	background-position center
	font-size: 32px;
	color: #FFFFFF;
	
.applyForm-lineUp
	position relative
	.avatarImg
		width 56px
		height 56px
		border-radius 50%
.applyForm-lineUp >>> .van-uploader
	position absolute
	left 0
	top 0
	width 100%
	height 100%
	opacity 0
.applyForm-lineUp >>> .van-uploader__wrapper
	width 100%
	height 100%
.applyForm-lineUp >>> .van-uploader__upload
	width 100%
	height 100%
	margin 0
.applyForm
	width 100%
	background #FFFFFF
	border-radius 40px 40px 0px 0px
	padding 40px 30px
	padding-top 0
	// margin-top -100px
	.applyForm-title
		img
			width 38px
			height 46px
		.text
			margin-left -26px
			font-size 32px
			font-weight bold
			color #000000
	.applyForm-line
		padding 36px 0
		font-size 28px
		color #232220
		border-bottom 1px solid #E6E6E6
		.right
			text-align right
			font-size 28px
			color #B1B1B1
			.right-item
				width 128px
				height 52px
				line-height 52px
				text-align center
				border 2px solid #DE113C
				border-radius 26px
				font-size 28px
				color #DE113C
				margin-right 20px
		.arrow
			width 14px
			height 30px
			margin-left 16px
		input
			text-align right
			font-size 28px
			color #333333
		input::-webkit-input-placeholder
			color #B1B1B1
			font-size 28px
		input::-moz-placeholder /* Mozilla Firefox 19+ */
			color #B1B1B1
			font-size 28px
		input:-moz-placeholder /* Mozilla Firefox 4 to 18 */
			color #B1B1B1
			font-size 28px
		input:-ms-input-placeholder /* Internet Explorer 10-11 */
			color #B1B1B1
			font-size 28px
	.applyForm-col
		padding 36px 0
		border-bottom 1px solid #E6E6E6
		.title
			font-size 28px
			font-weight bold
			color #232220
		.textList
			margin-top 28px
			width 100%
			height 120px
			textarea
				width 100%
				height 100%
				background-color #FFFFFF
				border none
				resize none
				font-size 28px
				color #000000
			textarea::-webkit-input-placeholder
				font-size 28px
				color #B1B1B1
			textarea:-moz-placeholder
				font-size 28px
				color #B1B1B1
			textarea::-moz-placeholder
				font-size 28px
				color #B1B1B1
			textarea::-ms-input-placeholder
				font-size 28px
				color #B1B1B1
	.applyPicTitle
		margin 34px 0
		font-size 28px
		font-weight bold
		color #000000
</style>
